// ============================================
// ZENTRA - JOB DATA
// Data lowongan kerja untuk aplikasi ZENTRA
// ============================================

export const allJobs = [
  // ===== TEKNOLOGI / IT =====
  {
    id: 1,
    title: "Frontend Developer",
    company: "PT TechCorp Indonesia",
    logo: "seed/co1/40/40",
    location: "Jakarta",
    type: "Full-time",
    experience: "Mid",
    salary: "Rp 12 - 20 Juta",
    salaryNum: 16,
    category: "IT & Software",
    posted: "2 jam lalu",
    urgent: true,
    tags: ["React", "TypeScript", "Tailwind CSS", "Next.js"],
    desc: "Membangun dan mengembangkan aplikasi web menggunakan React dan TypeScript. Bertanggung jawab untuk membuat user interface yang responsif dan performant."
  },
  {
    id: 2,
    title: "Backend Engineer",
    company: "PT Gojek Engineering",
    logo: "seed/co2/40/40",
    location: "Jakarta",
    type: "Full-time",
    experience: "Mid",
    salary: "Rp 14 - 22 Juta",
    salaryNum: 18,
    category: "IT & Software",
    posted: "3 jam lalu",
    urgent: false,
    tags: ["Go", "Microservices", "Kubernetes", "PostgreSQL"],
    desc: "Design dan implementasi microservices yang scalable untuk platform transportasi dan logistik terbesar di Indonesia."
  },
  {
    id: 3,
    title: "DevOps Engineer",
    company: "PT Traveloka Infra",
    logo: "seed/co3/40/40",
    location: "Remote",
    type: "Contract",
    experience: "Mid",
    salary: "Rp 16 - 25 Juta",
    salaryNum: 20.5,
    category: "IT & Software",
    posted: "5 jam lalu",
    urgent: true,
    tags: ["AWS", "Docker", "Kubernetes", "CI/CD", "Terraform"],
    desc: "Bangun dan maintain infrastructure yang reliable dan scalable untuk platform travel terbesar di Asia Tenggara."
  },
  {
    id: 4,
    title: "iOS Developer",
    company: "PT Shopee Engineering",
    logo: "seed/co4/40/40",
    location: "Jakarta",
    type: "Full-time",
    experience: "Mid",
    salary: "Rp 13 - 21 Juta",
    salaryNum: 17,
    category: "IT & Software",
    posted: "1 hari lalu",
    urgent: false,
    tags: ["Swift", "UIKit", "SwiftUI", "iOS"],
    desc: "Develop dan maintain iOS app untuk jutaan pengguna Shopee di seluruh Asia Tenggara."
  },
  {
    id: 5,
    title: "Full Stack Developer",
    company: "PT Bukalapak Tech",
    logo: "seed/co5/40/40",
    location: "Bandung",
    type: "Full-time",
    experience: "Senior",
    salary: "Rp 18 - 28 Juta",
    salaryNum: 23,
    category: "IT & Software",
    posted: "2 hari lalu",
    urgent: false,
    tags: ["React", "Node.js", "MongoDB", "GraphQL"],
    desc: "Membangun aplikasi full stack untuk marketplace terkemuka di Indonesia dengan arsitektur modern."
  },

  // ===== DATA & ANALYTICS =====
  {
    id: 6,
    title: "Data Analyst",
    company: "PT Bank Mandiri Digital",
    logo: "seed/co6/40/40",
    location: "Jakarta",
    type: "Full-time",
    experience: "Junior",
    salary: "Rp 8 - 12 Juta",
    salaryNum: 10,
    category: "Data",
    posted: "5 jam lalu",
    urgent: false,
    tags: ["SQL", "Python", "Tableau", "Power BI"],
    desc: "Analisis data nasabah untuk insight bisnis dan decision support di Bank Mandiri."
  },
  {
    id: 7,
    title: "Data Scientist",
    company: "PT GoTo Financial",
    logo: "seed/co7/40/40",
    location: "Jakarta",
    type: "Full-time",
    experience: "Senior",
    salary: "Rp 20 - 30 Juta",
    salaryNum: 25,
    category: "Data",
    posted: "3 hari lalu",
    urgent: false,
    tags: ["Python", "Machine Learning", "TensorFlow", "Big Data"],
    desc: "Mengembangkan model machine learning untuk deteksi fraud dan personalisasi rekomendasi produk."
  },

  // ===== DESIGN =====
  {
    id: 8,
    title: "UX Designer",
    company: "PT Tokopedia Design",
    logo: "seed/co8/40/40",
    location: "Remote",
    type: "Full-time",
    experience: "Senior",
    salary: "Rp 18 - 28 Juta",
    salaryNum: 23,
    category: "Design",
    posted: "1 hari lalu",
    urgent: false,
    tags: ["Figma", "Design System", "User Research", "Prototyping"],
    desc: "Rancang user experience yang intuitif untuk ecosystem e-commerce Tokopedia dengan pendekatan human-centered design."
  },
  {
    id: 9,
    title: "UI/UX Designer",
    company: "PT Unilever Digital",
    logo: "seed/co9/40/40",
    location: "Jakarta",
    type: "Full-time",
    experience: "Mid",
    salary: "Rp 12 - 18 Juta",
    salaryNum: 15,
    category: "Design",
    posted: "2 hari lalu",
    urgent: false,
    tags: ["Figma", "Adobe XD", "Design Thinking", "User Testing"],
    desc: "Mendesain antarmuka digital untuk produk-produk Unilever yang digunakan oleh jutaan konsumen di Indonesia."
  },

  // ===== MARKETING =====
  {
    id: 10,
    title: "Digital Marketing Manager",
    company: "PT BCA Digital",
    logo: "seed/co10/40/40",
    location: "Surabaya",
    type: "Full-time",
    experience: "Senior",
    salary: "Rp 15 - 22 Juta",
    salaryNum: 18.5,
    category: "Marketing",
    posted: "2 hari lalu",
    urgent: false,
    tags: ["Digital Marketing", "SEO", "Google Ads", "Social Media"],
    desc: "Kembangkan strategi marketing digital untuk produk perbankan BCA agar menjangkau lebih banyak nasabah potensial."
  },
  {
    id: 11,
    title: "Content Writer",
    company: "PT Kompas Gramedia",
    logo: "seed/co11/40/40",
    location: "Yogyakarta",
    type: "Part-time",
    experience: "Entry Level",
    salary: "Rp 4 - 7 Juta",
    salaryNum: 5.5,
    category: "Marketing",
    posted: "5 hari lalu",
    urgent: false,
    tags: ["Copywriting", "SEO", "Content Strategy", "Social Media"],
    desc: "Buat konten engaging untuk platform digital Kompas Gramedia dengan fokus pada SEO dan engagement reader."
  },

  // ===== FINANCE =====
  {
    id: 12,
    title: "Financial Analyst",
    company: "PT Unilever Indonesia",
    logo: "seed/co12/40/40",
    location: "Jakarta",
    type: "Full-time",
    experience: "Junior",
    salary: "Rp 7 - 11 Juta",
    salaryNum: 9,
    category: "Finance",
    posted: "4 hari lalu",
    urgent: false,
    tags: ["Financial Modeling", "Excel", "SAP", "Forecasting"],
    desc: "Analisis laporan keuangan dan forecast untuk business planning di perusahaan FMCG terbesar di Indonesia."
  },
  {
    id: 13,
    title: "Finance Manager",
    company: "PT Astra International",
    logo: "seed/co13/40/40",
    location: "Jakarta",
    type: "Full-time",
    experience: "Senior",
    salary: "Rp 20 - 30 Juta",
    salaryNum: 25,
    category: "Finance",
    posted: "3 hari lalu",
    urgent: false,
    tags: ["Financial Strategy", "Budgeting", "Risk Management", "Audit"],
    desc: "Memimpin tim finance untuk mengelola keuangan perusahaan dan strategi investasi."
  },

  // ===== HR & SDM =====
  {
    id: 14,
    title: "HR Business Partner",
    company: "PT Astra International",
    logo: "seed/co14/40/40",
    location: "Jakarta",
    type: "Full-time",
    experience: "Senior",
    salary: "Rp 12 - 18 Juta",
    salaryNum: 15,
    category: "HR",
    posted: "3 hari lalu",
    urgent: false,
    tags: ["People Development", "HR Strategy", "Compliance", "Talent Management"],
    desc: "Partner dengan business unit untuk menyusun strategi people & culture yang mendukung pertumbuhan perusahaan."
  },
  {
    id: 15,
    title: "Recruitment Specialist",
    company: "ZENTRA",
    logo: "seed/co15/40/40",
    location: "Jakarta",
    type: "Full-time",
    experience: "Mid",
    salary: "Rp 10 - 15 Juta",
    salaryNum: 12.5,
    category: "HR",
    posted: "1 hari lalu",
    urgent: true,
    tags: ["Recruitment", "Talent Acquisition", "Interviewing", "HRIS"],
    desc: "Kelola proses rekrutmen dari sourcing hingga onboarding untuk memenuhi kebutuhan talenta di ZENTRA."
  },

  // ===== OPERATIONS =====
  {
    id: 16,
    title: "Operations Manager",
    company: "PT Grab Indonesia",
    logo: "seed/co16/40/40",
    location: "Surabaya",
    type: "Full-time",
    experience: "Senior",
    salary: "Rp 15 - 23 Juta",
    salaryNum: 19,
    category: "Operations",
    posted: "5 hari lalu",
    urgent: false,
    tags: ["Process Improvement", "Team Leadership", "KPI", "Operational Excellence"],
    desc: "Optimasi proses operasional untuk meningkatkan efisiensi dan kualitas layanan Grab di wilayah Jawa Timur."
  },

  // ===== PRODUCT =====
  {
    id: 17,
    title: "Product Manager",
    company: "PT Digital Nusantara",
    logo: "seed/co17/40/40",
    location: "Jakarta",
    type: "Full-time",
    experience: "Mid",
    salary: "Rp 15 - 25 Juta",
    salaryNum: 20,
    category: "Product",
    posted: "2 jam lalu",
    urgent: true,
    tags: ["Product Strategy", "Agile", "Data-Driven", "Roadmapping"],
    desc: "Lead product strategy dan roadmap untuk platform HR SaaS yang digunakan oleh ratusan perusahaan di Indonesia."
  },
  {
    id: 18,
    title: "Product Designer",
    company: "PT Gojek Design",
    logo: "seed/co18/40/40",
    location: "Jakarta",
    type: "Full-time",
    experience: "Senior",
    salary: "Rp 18 - 27 Juta",
    salaryNum: 22.5,
    category: "Product",
    posted: "2 hari lalu",
    urgent: false,
    tags: ["Product Design", "UX Research", "Prototyping", "Design System"],
    desc: "Mendesain produk digital yang digunakan oleh jutaan pengguna Gojek di seluruh Indonesia."
  },

  // ===== SALES =====
  {
    id: 19,
    title: "Sales Manager",
    company: "PT Unilever Sales",
    logo: "seed/co19/40/40",
    location: "Bandung",
    type: "Full-time",
    experience: "Mid",
    salary: "Rp 12 - 18 Juta",
    salaryNum: 15,
    category: "Sales",
    posted: "4 hari lalu",
    urgent: false,
    tags: ["Sales Strategy", "Negotiation", "CRM", "Business Development"],
    desc: "Memimpin tim sales untuk mencapai target penjualan dan mengembangkan pangsa pasar Unilever."
  },
  {
    id: 20,
    title: "Business Development",
    company: "PT Tokopedia Growth",
    logo: "seed/co20/40/40",
    location: "Jakarta",
    type: "Full-time",
    experience: "Mid",
    salary: "Rp 10 - 16 Juta",
    salaryNum: 13,
    category: "Sales",
    posted: "3 hari lalu",
    urgent: false,
    tags: ["Business Development", "Partnership", "Market Expansion", "Strategic Planning"],
    desc: "Mengembangkan kemitraan strategis dan ekspansi bisnis Tokopedia ke segmen pasar baru."
  },

  // ===== ENGINEERING =====
  {
    id: 21,
    title: "Civil Engineer",
    company: "PT Wijaya Karya",
    logo: "seed/co21/40/40",
    location: "Jakarta",
    type: "Full-time",
    experience: "Junior",
    salary: "Rp 7 - 10 Juta",
    salaryNum: 8.5,
    category: "Engineering",
    posted: "1 minggu lalu",
    urgent: false,
    tags: ["Civil Engineering", "Project Management", "AutoCAD", "Construction"],
    desc: "Mengelola proyek konstruksi dan infrastruktur dari perencanaan hingga pelaksanaan."
  },
  {
    id: 22,
    title: "Mechanical Engineer",
    company: "PT Astra Manufacturing",
    logo: "seed/co22/40/40",
    location: "Surabaya",
    type: "Full-time",
    experience: "Mid",
    salary: "Rp 10 - 15 Juta",
    salaryNum: 12.5,
    category: "Engineering",
    posted: "5 hari lalu",
    urgent: false,
    tags: ["Mechanical Engineering", "CAD", "Manufacturing", "Quality Control"],
    desc: "Merancang dan mengoptimasi proses manufaktur untuk produk-produk Astra."
  }
];

// ============================================
// HELPER FUNCTIONS
// ============================================

// Fungsi untuk mendapatkan job berdasarkan ID
export const getJobById = (id) => {
  return allJobs.find(job => job.id === id);
};

// Fungsi untuk mendapatkan job berdasarkan kategori
export const getJobsByCategory = (category) => {
  return allJobs.filter(job => job.category === category);
};

// Fungsi untuk mendapatkan semua kategori unik
export const getUniqueCategories = () => {
  const categories = allJobs.map(job => job.category);
  return [...new Set(categories)];
};

// Fungsi untuk mendapatkan semua lokasi unik
export const getUniqueLocations = () => {
  const locations = allJobs.map(job => job.location);
  return [...new Set(locations)];
};

// Fungsi untuk mendapatkan job terbaru
export const getLatestJobs = (limit = 5) => {
  return [...allJobs]
    .sort((a, b) => {
      const order = { 'jam': 1, 'hari': 2, 'minggu': 3 };
      const getOrder = (str) => {
        if (str.includes('jam')) return order.jam;
        if (str.includes('hari')) return order.hari;
        if (str.includes('minggu')) return order.minggu;
        return 4;
      };
      return getOrder(a.posted) - getOrder(b.posted);
    })
    .slice(0, limit);
};

// Fungsi untuk mendapatkan job urgent
export const getUrgentJobs = () => {
  return allJobs.filter(job => job.urgent === true);
};

// Fungsi untuk mendapatkan statistik kategori
export const getCategoryStats = () => {
  const stats = {};
  allJobs.forEach(job => {
    if (stats[job.category]) {
      stats[job.category]++;
    } else {
      stats[job.category] = 1;
    }
  });
  return stats;
};

// ============================================
// EXPORT DEFAULT
// ============================================

export default allJobs;
